import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {StatsCategoryDomainModel} from "./stats-category.domain-model";
import {OrderByPositionDomainModel} from "./orderByPosition/order-by-position.domain-model";
import {OrderByPositionViewModel} from "./orderByPosition/order-by-position.view-model";

export class StatsCategoryViewModel extends BaseViewModel {
  domainModel: StatsCategoryDomainModel;

  get orderLevel(): Number {
    return this.domainModel.orderLevel;
  }

  get orderByPosition(): Array<OrderByPositionViewModel> {
    return this.domainModel.orderByPosition.map((position: OrderByPositionDomainModel) => new OrderByPositionViewModel(position));
  }
}